<template>
  <IQOS 
    :title="mode == 'delivery' ? 'Контактний телефон доставки' : 'Контактний телефон'">
    <BaseInput class="w-100" placeholder="+380501234567" readonly :value="phone" v-if="!editing" />
    <BaseInput
      class="w-100"
      :readonly="false"
      v-model="phone"
      placeholder="+380501234567"
      v-if="editing"
    />

    <p
      class="c-grey title iqos-bottom-comment"
    >Ви можете вказати додатковий контактний телефон для {{ mode.toUpperCase() }}, якщо він відрізняється від основного телефону закладу.</p>

    <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import BlackInput from "@/components/BlackInput.vue";

export default {
  data() {
    return {
      editing: false,

      phone: "",
    };
  },
  props: {
    mode: {
      type: String,
      default: "delivery"
    }
  },
  components: {
    IQOS,
    IQOSActions,
    BlackInput
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.setInitialValue();
    },
    onPhoneMaskComplete(ev) {
      const detail = ev.detail;

      this.phone = detail.unmaskedValue;
    },
    onEditFinish() {
      if (!this.phone) return;

      if (this.mode == 'delivery') 
        this.$store.commit("setDeliveryContactPhone", this.phone);
      if (this.mode == 'preorder') 
        this.$store.commit("setPreorderContactPhone", this.phone);
      
      this.$store.dispatch("saveCafe");

      this.editing = false;
    },
    setInitialValue() {
      if (this.cafe[this.mode] && this.cafe[this.mode].contact_phone) {
        this.phone = this.cafe[this.mode].contact_phone;
      } else {
        this.phone = this.cafe.contact_phone;
      }
    }
  },
  mounted() {
    this.setInitialValue();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    }
  }
};
</script>

<style>
</style>